import React, { Component } from 'react';

import { Card, Icon, Button, Modal, Spin, Table, Popover, Radio } from 'antd';
import { inject, observer } from 'mobx-react';

import moment from 'moment';

import './IssuesCard.css';
import CarIcon from '../../../../../common/icons/CarIcon';
import { api } from '../../../../../services';

import { pick } from 'lodash';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class IssuesCard extends Component {
  constructor(props) {
    super(props);

    const { commonStore, translationsStore } = this.props;
    this.historyItemsPerPage = 10;
    this.historyTableColumns = [
      {
        dataIndex: 'code',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.code'),
        sorter: true,
        sortOrder: false,
        width: '80px',
        className: 'code',
        render: (text, record) => {
          let style = { textDecoration: 'underline' };
          return <span className={record.severity === 'red' ? 'red' : 'orange'}>{this.state.historyActiveKey === 'dtcs' ? <a style={style} className={record.severity === 'red' ? 'red' : 'orange'} onClick={e => {
            e.stopPropagation();
            this.showExtendedDTCs(record);
          }}>{text}</a> : text}</span>;
        }
      },
      {
        dataIndex: 'description',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.description'),
        sorter: true,
        sortOrder: false,
        render: (text, record) => ((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).description || record.description
      },
      {
        dataIndex: 'resolvedAt',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.resolvedAt'),
        sorter: true,
        sortOrder: false,
        width: '100px',
        render: text => moment(text).format(commonStore.longDateFormat.L)
      },
      {
        dataIndex: 'recordedAt',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.recordedAt'),
        sorter: true,
        sortOrder: false,
        width: '100px',
        render: text => moment(text).format(commonStore.longDateFormat.L)
      },
      {
        dataIndex: 'initialOdometer',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.initialOdometer'),
        sorter: true,
        sortOrder: false,
        render: text => Number(text).toLocaleString(commonStore.dateFnsLocale)
      },
      {
        dataIndex: 'km',
        title: this.props.translationsStore.translate('carView.IssuesCard.history.table.columns.km'),
        render: (text, record) => Number(record.km).toLocaleString(commonStore.dateFnsLocale)
      }
    ];
    this.historyFetchMethods = [
      {
        key: 'dtcs',
        method: 'getDtcsHistory',
        defaultSorter: { field: 'recordedAt', order: 'DESC' }
      },
      {
        key: 'alarms',
        method: 'getAlarmsHistory',
        defaultSorter: { field: 'recordedAt', order: 'DESC' }
      }
    ];

    this.state = {
      sorters: { dtcs: this.historyFetchMethods[0].defaultSorter, alarms: this.historyFetchMethods[1].defaultSorter }
    };

    this.showExtendedDTCs = record => {
      const { translationsStore } = this.props;

      return (Modal.info({
        icon: <div />,
        title: <span class="bold">{translationsStore.translate('carView.DTCsCard.extendedDescription')}</span>,
        width: 720,
        content: (
          <div>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.subcategoryDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).subcategoryDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.warningDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).warningDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.recommendationDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).recommendationDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.causeDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).causeDescription || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.effectDescription')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).effectDescription|| '-').replaceAll("\\n","<br/>") }}></div>
            </p>
            <p>
              <div class="bold">{translationsStore.translate('carView.DTCsCard.classification')}</div>
              <div dangerouslySetInnerHTML={{ __html: (((record.dtcTranslations||[]).find(translation => translation.language === translationsStore.locale) || {}).classification || '-').replaceAll("\\n","<br/>") }}></div>
            </p>
          </div>
        ),
        onOk() {},
      }));
    };
  }

  loadHistory = (methods = ['dtcs', 'alarms'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  switchHistory = e => {
    this.loadHistory([e.target.value]);
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  render() {
    const { translationsStore, commonStore, alarms, dtcs, lastConnection, kmPerDay, status, shutdown, offer, obdService } = this.props;
    const historySwitch = this.historyFetchMethods.filter(item => ((this.state.historyResources || []).find(helper => helper.key === item.key) || {}).count > 0);

    const { sorters, historyActiveKey } = this.state;
    const columns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });

    return (
      <Card className="IssuesCard" style={this.props.style}>
        <div className="header">
          <div>{translationsStore.translate('carView.IssuesCard.title')}</div>
          <Popover
            content={translationsStore.translate('carView.IssuesCard.historyNoData.message')}
            title={translationsStore.translate('carView.IssuesCard.historyNoData.title')}
            trigger="click"
            visible={this.state.historySum === 0 && this.state.historyNoDataHint}
            onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
          >
            <Button onClick={() => this.loadHistory()} type="primary" disabled={serviceLevelsWithLimitedFeatures.includes(this.props.serviceLevel)}>
              {translationsStore.translate('carView.history')}
            </Button>
          </Popover>
        </div>
        <div className="container">
          {!!kmPerDay && (
            <div className={`kmPerDay ${kmPerDay > 50 ? 'red' : kmPerDay > 16 ? 'orange' : 'green'}`}>
              <span>{translationsStore.translate('carView.IssuesCard.kmPerDay')}</span>
              <span>{Math.round(kmPerDay).toLocaleString()}</span>
              <CarIcon />
            </div>
          )}
          <div className="issues">
            <div className="status">
              <div className="title" style={{ textAlign: 'center' }}>
                {!obdService.loading && <div>{!offer ? '-' : translationsStore.translate(`carView.obdservice.${offer.toLowerCase()}.current.${obdService.current}`)}</div>}
                {obdService.loading && <div>loading...</div>}
              </div>
              <div className="value">
                {status ? <Icon type="heart" className={`${status} ${shutdown === null ? 'unknown' : shutdown === true ? 'shutdown' : 'noshutdown'}`} /> : <span>&mdash;</span>}
              </div>

              <div className="lastConnection">
                <div>{translationsStore.translate('carView.IssuesCard.lastConnection')}</div>
                <strong>{moment(lastConnection).format(commonStore.longDateFormat.L)}</strong>
                <strong>{moment(lastConnection).format(commonStore.longDateFormat.LT)}</strong>
              </div>
            </div>
            <div className="totals">
              <div className="title" style={{ textAlign: 'center' }}>
                {translationsStore.translate('carView.IssuesCard.totals')}
              </div>
              <div className="value">{(alarms || []).filter(alarm => alarm.present === true).length + (dtcs || []).length}</div>
            </div>
            <div className="alarms">
              <div className="title" style={{ textAlign: 'center' }}>
                {translationsStore.translate('lead.summary.alarms')}
              </div>
              <div className="value">{!!alarms && alarms.filter(alarm => alarm.present === true).length}</div>
            </div>
            <div className="dtcs red">
              <div className="title" style={{ textAlign: 'center' }}>
                {translationsStore.translate('lead.summary.dtcsRed')}
              </div>
              <div className="value">{!!dtcs && dtcs.filter(dtc => dtc.severity === 'red').length}</div>
            </div>
            <div className=" dtcs orange">
              <div className="title" style={{ textAlign: 'center' }}>
                {translationsStore.translate('lead.summary.dtcsOrange')}
              </div>
              <div className="value">{!!dtcs && dtcs.filter(dtc => dtc.severity === 'orange').length}</div>
            </div>
          </div>
        </div>
        <Modal
          title={translationsStore.translate('carView.IssuesCard.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('DTCsCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            <div style={{ marginBottom: 20 }}>
              {historySwitch.length > 0 && (
                <RadioGroup onChange={this.switchHistory} defaultValue={historySwitch[0].key}>
                  {historySwitch.map((item, index) => (
                    <RadioButton key={index} value={item.key}>
                      {translationsStore.translate(`carView.IssuesCard.history.panels.${item.key}`)}
                    </RadioButton>
                  ))}
                </RadioGroup>
              )}
            </div>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                  />
                )
            )}
          </Spin>
        </Modal>
      </Card>
    );
  }
}
